<template>
  <div class="sn-f-b-c sn-pointer app-func" v-if="func.length > 0">
    <div class="sn-f-1 sn-f-c-c func-single" :key="menu.key" v-for="menu in func" @click="goFunction('0', menu);">
      {{ menu.title }}
      <div class="expand"
      :class="{'actived': menu.func.length > 1}"
      :style="{'--serial': menu.func.length}" @click.stop="">
        <div class="sn-f-c-c" :key="menu.key + f.id" v-for="f in menu.func" @click="goFunction('1', f);">{{ f.alias }}</div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { ErrorConfig } from '@/common/utils/login-config';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import * as Messages from '@/common/utils/messages';

export default {
  name: 'app-func',
  mixins: [HomepageMixin],
  data() {
    return {
      func: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.eventBus.$on('Broadcast_HospitalFunctionTreeInformation', () => {
        this.formatFunc();
      });
    });
  },
  created: function() {
    this.formatFunc();
  },
  methods: {
    formatFunc() {
      this.func = [];
      const storage = this.$sn.utils.getHospitalSessionStorage('HospitalFunctionTreeInformation');
      if (!this.$sn.validate.empty(storage) && !this.$sn.validate.empty(Object.values(storage).find(result => result.title && result.enabled === '1' && result.func.length > 0))) {
        Object.keys(storage).forEach(key => {
          if (storage[key].title && storage[key].enabled === '1' && storage[key].func.length > 0) {
            this.func.push({
              ...storage[key],
              key
            });
          }
        });
      }
      if (this.$sn.getConfig('website')) {
        this.func.push({
          'key': 'SY',
          'title': '首页',
          'assembly': '',
          'sub': '',
          'enabled': '1',
          'sort': 0,
          'compare': {
            ['ordinary' + '84b5d43b']: {
              'alias': '首页',
              'url': this.$sn.getConfig('website'),
              'sort': 0,
              'remark': '',
              'params': ''
            }
          },
          'func': [{
            'id': 'ordinary' + '84b5d43b',
            'alias': '首页',
            'url': this.$sn.getConfig('website'),
            'sort': 0,
            'remark': '',
            'params': ''
          }]
        });
      }
      this.func = this.$sn.format.digitalSort(this.func);
    },
    goFunction(type, item) {
      let f = {};
      // 一级功能
      if (type === '0') {
        if (!this.$sn.validate.empty(item.func.find(result => this.$sn.utils.isOpenFunction(result.id)))) {
          f = item.func.find(result => this.$sn.utils.isOpenFunction(result.id));
        }
      }
      // 二级功能
      else if (type === '1') {
        if (this.$sn.utils.isOpenFunction(item.id)) f = item;
      }
      if (this.$sn.validate.empty(f)) {
        // 服务升级公告-当前功能暂未开放
        this.$sn.utils.setHospitalSessionStorage('Homepage_ErrorCaption', {
          title: Messages.C010,
          caption: Messages.C003
        });
        if (this.$route.path === ErrorConfig) window.eventBus.$emit('Broadcast_NavigatorFunction');
        else this.navigateUrl(ErrorConfig);
      }
      else {
        this.navigateUrl(f.url, f, f.params || {});
      }
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.app-func {
  width: 1280px;
  height: 50px;
  background-color: $white;
  border-top: 1px solid $border1;
  border-bottom: 1px solid $border1;

  .func-single {
    @include fs(16);

    height: 30px;
    border-right: 1px solid $border1;
    position: relative;

    &:last-child {
      border-right: none;
    }

    &:hover {
      color: $main;

      .actived {
        opacity: 1;
        height: calc(var(--serial) * 60px);
        border: 1px solid $main;
        box-shadow: 0 0 4px 2px $main9;
      }
    }

    .expand {
      opacity: 0;
      overflow: hidden;
      width: 200px;
      height: 0;
      background-color: $main4;
      color: $black;
      border-radius: 4px;
      padding: 0 10px;
      position: absolute;
      top: 50px;
      left: 50%;
      z-index: 999;
      transform: translateX(-50%);
      transition: linear 200ms;

      div {
        height: 60px;
        border-bottom: 1px dashed $main;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          color: $main;
        }
      }
    }
  }
}
</style>
